import React from "react";
import { Pressable, StyleSheet, Text } from "react-native";

type Props = {
  /** 編集ボタンクリック時の挙動を定義します */
  onEditClick: () => void;
  /** ボタンに表示するテキストを定義します */
  buttonText: string;
};
/**
 * 編集用のボタンを作成します
 * @param param0
 * @returns
 */
export const MobileTableEditButton = ({ onEditClick, buttonText }: Props) => {
  return (
    <Pressable
      style={[styles.editButton, { backgroundColor: "#7879F1" }]}
      onPress={onEditClick}
    >
      <Text style={styles.buttonText}>{buttonText}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  editButton: {
    top: 0,
    left: 0,
    right: 0,
    borderRadius: 20,
    elevation: 5,
    width: 100,
    height: 35,
    textAlign: "center",
  },
  buttonText: {
    textAlign: "center",
    color: "#fff",
    lineHeight: 30,
  },
});
